module.exports = __webpack_public_path__ + "static/img/2-2.579fc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2-2.png
// module id = VNDv
// module chunks = 1